import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20warm%20toned%20geometric%20pattern%20with%20soft%20terracotta%20coral%20and%20cream%20shapes%20overlapping%2C%20minimalist%20modern%20design%2C%20subtle%20gradient%20texture%2C%20no%20text%2C%20clean%20European%20fashion%20website%20background%2C%20gentle%20organic%20curves%2C%20elegant%20warm%20composition&width=1600&height=900&seq=hero-bg-v3&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska tło"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-center gap-10 md:gap-16 py-20 md:py-0">
        <div className="flex-1 text-left">
          <p className="inline-block px-3 py-1 bg-accent-100/80 text-accent-900 text-xs font-medium rounded-full mb-4">
            Updated 2026
          </p>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            Kakobuy Spreadsheet Polska
          </h1>
          <p className="text-lg md:text-xl text-background-50/90 font-heading italic mb-4">
            Best Kakobuy Spreadsheet 2026
          </p>
          <p className="text-sm md:text-base text-background-50/70 max-w-lg mb-8 leading-relaxed">
            Odkryj{' '}
            <Link to="/kakobuy-spreadsheet-polska/" className="text-accent-400 hover:text-accent-300 underline underline-offset-2">
              Kakobuy Spreadsheet Polska
            </Link>{' '}
            &mdash; najlepszy sposób na znalezienie produktów na Kakobuy.{' '}
            <Link to="/best-kakobuy-spreadsheet-2026/" className="text-accent-400 hover:text-accent-300 underline underline-offset-2">
              Best Kakobuy Spreadsheet 2026
            </Link>{' '}
            oferuje aktualne listy, porównania i rekomendacje dla użytkowników z Polski.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-100 transition-all text-center whitespace-nowrap cursor-pointer"
            >
              kakobuy spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all text-center whitespace-nowrap cursor-pointer"
            >
              buy it now
            </a>
          </div>
        </div>

        <div className="flex-1 hidden lg:flex items-center justify-center">
          <div className="relative w-full max-w-[480px] aspect-[4/5]">
            <img
              src="https://readdy.ai/api/search-image?query=Curated%20fashion%20essentials%20flatlay%20with%20premium%20sneakers%20folded%20cashmere%20sweater%20and%20minimalist%20watch%20on%20warm%20oatmeal%20linen%20surface%2C%20soft%20natural%20morning%20light%2C%20elegant%20European%20editorial%20style%2C%20clean%20composition%2C%20warm%20terracotta%20accents%2C%20no%20branding%2C%20luxury%20product%20display&width=960&height=1200&seq=hero-product-v3&orientation=portrait"
              alt="Kakobuy Spreadsheet produkty"
              className="w-full h-full object-cover object-top rounded-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}